import React, { useContext, useEffect, useState } from "react";
import { Checkbox, IconButton } from "@mui/material";

// import { LoginContext } from "../../../context/login-context";
import { DataGrid, Icon } from "../../components";
import { LoginContext } from "../../context/login-context";

const DealerFarmsBlock = ({farms, onAddFarm, onRemoveFarm, onEditFarm }) => {
  const { state: userData } = useContext(LoginContext);
  
  const columns = [
    {
      field: "name",
      headerName: "Name",

      renderCell: (params) => {
        return (
          <>
            {params.row?.name}
          </>
        )
      },
    },

    {
      field: "action",
      headerName: "",
      sortable: false,
      align: "right",
      renderCell: (params) => {
        return (
          <>

          <IconButton  >
              <Icon icon="ChevronRight" />
            </IconButton>
          </>
        );
      },
    },
  ];

	return (
		<DataGrid
            toolbarBtnVisible={userData?.isValmontUser}
			toolbarTitle={'Farms'}
			toolbarBtnTitle={`+ Add New Farm(s)`}
			toolbarOnClick={onAddFarm}
            rows={farms}
			columns={columns}
            onRowClick={(params) => {
                onEditFarm(params.row);
                if(userData?.isValmontUser) onEditFarm(params?.row);
            }}
            sx={{
                '& .MuiDataGrid-columnSeparator': {
                display: 'none',
                },
            }}
		/>
	);
};

export default DealerFarmsBlock;
